<template>
  <WdsStack direction-row gap-sm align-center>
    <WdsText v-if="meta.filter.quickFilter" :text="$t(fieldToReadAble(meta.filter.inputArgName))" />
    <WdsSelect
      v-model="state"
      class="tw-w-full"
      :list
      can-deselect
      :placeholder="$t('Yes - No')"
      :title="$t(meta.filter.description)"
      :label="meta.filter.quickFilter ? '' : $t(fieldToReadAble(meta.filter.inputArgName))"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { ModelRef, computed } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { fieldToReadAble } from '@/components/GraphqlDataTable/tools'

const { meta } = defineProps<{ meta: FilterMetaDataProp }>()

const boolState: ModelRef<boolean | null> = defineModel({
  default: () => null,
})

const state = computed({
  get() {
    if (boolState.value !== null) {
      return boolState.value
        ? {
            label: $t('Yes'),
            value: true,
          }
        : {
            label: $t('No'),
            value: false,
          }
    }
    return boolState.value
  },
  set(stateVal: { value: boolean } | null) {
    if (stateVal === null) {
      boolState.value = null
    } else {
      boolState.value = stateVal.value
    }
  },
})

const list = [
  {
    label: $t('Yes'),
    value: true,
  },
  {
    label: $t('No'),
    value: false,
  },
]
</script>
